import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from '@algoan/dashboard/store/store';
import { NotificationBar } from './notification-bar';
import { notificationSelector, notificationStatusSelector } from '@algoan/dashboard/store/selectors';
import { popNotificationFinish } from '@algoan/dashboard/store/slice';

export const Notification: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const notification = useSelector(notificationSelector);
  const notificationStatus = useSelector(notificationStatusSelector);

  // Cleanup the notification state if the component unmount before setTimeout useEffect is finish
  useEffect(() => {
    return () => {
      if (notification) dispatch(popNotificationFinish());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NotificationBar status={notificationStatus} variant={notification?.type}>
      {notification && intl.formatMessage(notification.message, notification.value)}
    </NotificationBar>
  );
};
